import axios from "./index";

type LlmAssessmentStatus = "unprocessed" | "processing" | "completed" | "failed";

type ConsultationPreprocessingRequestApiResponse = {
  llmAssessmentStatus: LlmAssessmentStatus;
  questions: Array<{
    id: number;
    question: string;
    quote: string | null;
  }>;
  assessmentDraft: {
    complaint: string | null;
    urgency: "immediate" | "soon" | "watchful_waiting" | "no_assessment_needed" | null;
    body: string | null;
    icd10BranchCandidates: Array<{
      id: number;
      name: string;
    }>;
  } | null;
};

type FetchParams = {
  consultationId?: number | string;
};

const consultationPreprocessingRequestsApi = {
  fetch({ consultationId }: FetchParams): Promise<ConsultationPreprocessingRequestApiResponse | undefined> {
    if (!consultationId) return Promise.resolve(undefined);

    return axios
      .get("/api/v1/consultation_preprocessing_requests", {
        params: { anytime_consultation_id: consultationId },
      })
      .then((response) => response?.data as ConsultationPreprocessingRequestApiResponse | undefined);
  },
};

export default consultationPreprocessingRequestsApi;
